import Rate from './rate';

function rate(props) {
  return new Rate(props);
}

export default rate;


//////////////////
// WEBPACK FOOTER
// ./~/codeages-design/src/lib/rate/index.js
// module id = 564
// module chunks = 9